import { Spinner } from 'react-bootstrap';

type LoadingProps = {
  text?: string;
};

function Loading({ text = 'Loading' }: LoadingProps) {
  return (
    <div className="d-flex align-items-center justify-content-center gap-4">
      <Spinner animation="border" />
      <span>{text}</span>
    </div>
  );
}

export default Loading;
